import React from 'react';
import { StethoscopeIcon } from 'lucide-react';
import { OfferBlock } from '../OfferBlock';
import { HERO_MOCKUP } from '../../data/content';
export function Hero() {
  return <header className="relative overflow-hidden bg-cream px-4 pb-14 pt-8 sm:px-6 sm:pb-20 sm:pt-12" data-id="element-162" data-mp="cvun47r7sjp8">
      <div className="mx-auto max-w-4xl" data-id="element-163" data-mp="huxpfkft8bti">
        <div className="flex flex-col items-center gap-3 sm:flex-row sm:justify-center" data-id="element-164" data-mp="hvqsaabneh6d">
          <div className="flex items-center gap-2" data-id="element-165" data-mp="mszcshk9qxas">
            <span className="flex h-9 w-9 items-center justify-center rounded-xl bg-navy-800 text-white" data-id="element-166" data-mp="ms7ntpl6fxth">
              <StethoscopeIcon className="h-5 w-5" aria-hidden="true" data-id="element-167" data-mp="vmc9zvpd8l2o" />
            </span>
            <span className="font-display text-xl font-bold text-navy-800" data-id="element-168" data-mp="vootidarv3hu">
              GLP-1 Decision Map<sup className="text-[10px]" data-id="element-169" data-mp="10n9u4dtxrp6t">™</sup>
            </span>
          </div>
          <span className="rounded-full border border-navy-200 bg-white px-3 py-1.5 text-[10px] font-bold uppercase tracking-[0.1em] text-navy-700 sm:text-[11px]" data-id="element-170" data-mp="15mcydw23drdq">
            🏥 The GLP-1 Decision Map™
          </span>
        </div>

        <h1 className="mt-7 text-center font-display text-[32px] font-bold leading-[1.1] text-navy-800 sm:text-5xl lg:text-[56px]" data-id="element-171" data-mp="4ozlo3co6og5">
          Organize your GLP-1 consultation{' '}
          <em className="italic text-teal-600" data-id="element-172" data-mp="3vwu7a2adcmf2">in under 10 minutes</em>
        </h1>

        <p className="mx-auto mt-5 max-w-2xl text-center text-[15px] leading-relaxed text-navy-700/85 sm:text-lg" data-id="element-173" data-mp="3rv8qw6ymlq04">
          A visual, step-by-step clinical organization system that helps you structure what to
          review, what to verify, what to document, and what to prepare at every stage of a GLP-1
          consultation. Includes <strong className="font-bold text-navy-800" data-id="element-174" data-mp="en5kud73dghb">6 clinical volumes</strong>,{' '}
          <strong className="font-bold text-navy-800" data-id="element-175" data-mp="1b4s3gs5hppzt">5 professional tools</strong>, decision maps and
          checklists.
        </p>

        <img src={HERO_MOCKUP} alt="The GLP-1 Decision Map system: 6 clinical volumes, digital tools and 5 bonuses" className="mx-auto mt-8 w-full max-w-3xl" width={1080} height={1080} data-id="element-176" data-mp="16dtihf9k43q8" />

        <div className="mt-8" data-id="element-177" data-mp="35n37ib4i647t">
          <OfferBlock id="hero-cta" label="Get the GLP-1 Decision Map™" note="Instant download · One-time payment of $27 USD (automatic currency conversion) · Lifetime access · 7-day guarantee" data-id="element-178" data-mp="2qwdsexnx84yo" />
        </div>
      </div>
    </header>;
}